<template>
    <div class="layout-container">
        <el-tabs type="border-card">

             <el-tab-pane label="IM咨询统计">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="IMCondition.site_id" :clueId=1 :init-choose-first="false" :owned='true' ref="siteAutoCompleteIm"  @created="initData"></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="IMCheckDate('month')" :class="IMCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="IMCheckDate('doubleMonth')" :class="IMCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="IMCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="IMCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">线索获取方式</span>
                            <div class="input-condition">
                                <el-select v-model="IMCondition.source_id">
                                <el-option
                                    v-for="(item, key) in imType"
                                    :value="item.id"
                                    :label="item.name"
                                    :key="key"
                                ></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                         <el-button-group style="margin-left:20px;">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="download"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                <div class="totalData" v-if="IMTotal">
                    <div class="item">
                        <p><span>{{IMTotal.people_num_total}}</span></p>
                        <label>咨询人数</label>
                    </div>
                    <div class="item">
                        <p><span>{{IMTotal.consult_num_total}}</span></p>
                        <label>咨询次数</label>
                    </div>
                    <div class="item">
                        <p><span>{{IMTotal.no_distinct_total}}</span><span>(去重：{{IMTotal.distinct_mobile_count}})</span></p>
                        <label>线索量</label>
                    </div>
                    <!-- <div class="item">
                        <p>{{IMTotal.rate}}%</p>
                        <label>获客率</label>
                    </div> -->
                   
                </div>
                <el-table
                        :data="IMDataList"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        @sort-change="IMSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="日期" prop="created_date" sortable='custom'></el-table-column>
                    <el-table-column label="咨询人数" prop="people_num" sortable='custom'></el-table-column>
                    <el-table-column label="咨询次数" prop="consult_num" sortable='custom'></el-table-column>
                    <el-table-column label="线索量" prop="no_distinct_total" sortable='custom'></el-table-column>
                    <el-table-column label="线索量(去重)" prop="distinct_mobile_count"></el-table-column>

                    <!-- <el-table-column label="获客率" prop="rate" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.rate}}%</span>
                        </template>
                    </el-table-column> -->
                </el-table>
                <template v-if="IMDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="IMCondition.page"  :total="imListNum" :page-size="IMCondition.per_page" @current-change="IMCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import { getImAnalysis} from '@/service/customer'
    import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
    import { parseTime } from '@/utils'
    export default {
        name: "List",
        components: {
            SiteAutoComplete
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                IMCondition:{ //IM
                    time: '',
                    timeStamp: 'month',
                    page:1,
                    per_page:10,
                    source_id:0,
                    site_id:'',
                },
                 imType:[
                     {
                        id : 0,
                        name : '全部'
                    },
                     {
                        id : 4,
                        name : 'IM用户授权'
                    },
                     {
                        id :5,
                        name : 'IM主动预留'
                    }
                ],
                site_id:null,
                imListNum:0,
                IMTotal:null,
                IMDataList:[],
                isLoading:true,
            }
        },
        methods: {
          
            resetSearch(){
                this.IMCondition={ 
                    time: '',
                    timeStamp: 'month',
                    page:1,
                    per_page:10,
                    source_id:0,
                    site_id:'',
                }
                this.$refs.multipleTable.columns.forEach(item => {
                    item.order = ''
                })
                this.$nextTick(() => {
                    this.$refs.siteAutoCompleteIm&& this.$refs.siteAutoCompleteIm.reset();
                })
            },
          handleSearch(){
              this.IMCondition.page = 1;
              this.initData();
          },
            //IM
            async initData(){
                this.isLoading = true
                let query =this.IMCondition
                query.per_page = 10;
                if (query.timeStamp.length > 0) {
                    let time_quantum = query.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(query.time && query.time.length > 0) {
                    query.start_time = Date.parse(new Date(query.time[0]))/1000
                    query.end_time = Date.parse(new Date(query.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }

                await getImAnalysis(query).then((data) => {
                    if(data.data.length){
                        this.IMDataList=data.data;
                    }else{
                        this.IMDataList=[]
                    }
                    this.IMTotal=data.dataTotal;
                    this.imListNum=data.total
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            IMSortChange(column){
                if(!this.IMDataList.length){
                    return
                }
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else if(column.order == 'ascending'){
                    order='asc'
                }else{
                    order=""
                }
                if(column.prop == 'created_date'){
                    this.IMCondition.sort_name='created_time'
                }else if(!order){
                    this.IMCondition.sort_name = ""
                }else{
                    this.IMCondition.sort_name =column.prop
                }
                this.IMCondition.sort_order = order
                this.initData()
            },
            IMCheckDate (value) {
                this.IMCondition = Object.assign({}, this.IMCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            IMCurrentChange(index){
                this.IMCondition.page = index
                this.initData()
            },
            async download () {
                let start,end;
                let query = {...this.IMCondition}
                query.per_page = 1000;
                if (query.timeStamp.length > 0) {
                    let time_quantum = query.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                    start = parseTime(query.start_time,'{y}-{m}-{d}');
                    end = parseTime(query.end_time,'{y}-{m}-{d}');
                } else if(query.time && query.time.length > 0) {
                    query.start_time = Date.parse(new Date(query.time[0]))/1000
                    query.end_time = Date.parse(new Date(query.time[1]))/1000
                    start = parseTime(query.start_time,'{y}-{m}-{d}');
                    end = parseTime(query.end_time,'{y}-{m}-{d}');
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                import('@/vendor/Export2Excel').then(async excel => {
                    const tHeader = ['站点','日期','咨询人数','咨询次数','线索量']
                    const filterVal = ['site_name','created_date', 'people_num', 'consult_num', 'no_distinct_total']
                    let list = []
                   
                    this.isLoading = true
                    // 模拟fetch请求数据....
                    await getImAnalysis(query).then((data) => {
                        let listData = data.data
                        for (let i in listData) {
                            listData[i].rateStr = listData[i].rate+'%';
                        }
                        list = listData
                    })
                    const formatJson = (filterVal) => {
                        return list.map(v => filterVal.map(j => {
                            return v[j]
                        }))
                    }
                    let name = 'IM咨询统计'
                    if (this.IMCondition.time.length > 0 || this.IMCondition.timeStamp) {
                        name += start + '至' + end
                    }
                    const data = formatJson(filterVal)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: name
                    })
                    this.isLoading = false
                })
            },
        }
    }
</script>

<style scoped>
    .totalData{
        height: 100px;
        margin: 30px 40px 0;
    }
    .totalData .item{
        width: 15%;
        float: left;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
    }
    
</style>
